import React from 'react';
import { Link } from 'react-router-dom';
import { deletionMessage } from '../domain/accountDeletion';
import s from './AccountDeletedPage.module.css';

// What a teacher sees after deleting their account (#432): that it is done,
// what is still happening (the purge runs on the server), and that nothing
// more will be charged. The words are the core's, so the phones say the same.
//
// Outside every guard in App.jsx: nobody is signed in by the time it renders,
// and a signed-in visitor who types the address is shown a true sentence about
// somebody else's account only if they deleted one — which is harmless.
export default function AccountDeletedPage() {
  return (
    <main className={s.page}>
      <div className={s.card}>
        <h1 className={s.title}>{deletionMessage('doneTitle')}</h1>
        <p className={s.body}>{deletionMessage('doneBody')}</p>
        <Link className={s.link} to="/login">Back to sign in</Link>
      </div>
    </main>
  );
}
